import React, { useState, createContext } from "react";
import { useAuth } from "./AuthContext";
import { useHistory } from "react-router-dom";
import { db, auth } from "../firebase";

export const SignupInfoContext = createContext();

const SignupInfoProvider = ({ children }) => {
  const history = useHistory();
  const { signup } = useAuth();
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const [info, setInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    isSalary: true,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (info.password !== info.confirmPassword) {
      console.log("errorMsg");
      return setErrorMsg("Password Does not match");
    }

    try {
      setErrorMsg("");
      setLoading(true);
      await signup(info.email, info.password);
      const defaultImage =
        "https://firebasestorage.googleapis.com/v0/b/mpocket-c11f8.appspot.com/o/MPocket%2Fdefault.jpg?alt=media";
      const usersRef = db.users.doc(auth.currentUser.uid);
      usersRef
        .set({
          fname: info.firstName,
          lname: info.lastName,
          imageURL: defaultImage,
          email: info.email,
          isSalary: info.isSalary,
          createdAt: db.getCurrentTimeStamp(),
        })
        .then(() => {
          history.push("/Dashboard");
        })
        .catch((error) => {
          setErrorMsg(error.message);
        });

      setInfo({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
        isSalary: true,
      });
    } catch (error) {
      setErrorMsg(error.message);
    }
    setLoading(false);
  };

  const value = {
    info,
    setInfo,
    handleSubmit,
    errorMsg,
    loading,
  };

  return (
    <SignupInfoContext.Provider value={value}>
      {children}
    </SignupInfoContext.Provider>
  );
};

export default SignupInfoProvider;
